import { api } from "..";
import { QueryProps } from "@/types/Api";

export interface BettingRules {
  minStakeAmount?: number;
  maxStakeAmount?: number;
  maxPayoutAmount?: number;
  minSelectionsCount?: number;
  maxSelectionsCount?: number;
  maxTotalOdds?: number;
  lineMinOdds?: number;
  lineMaxOdds?: number;
  lineOddsAdjustment?: number;
  lineMinOddsViolationAction?: string;
  lineMaxOddsViolationAction?: string;
  liveMinOdds?: number;
  liveMaxOdds?: number;
  liveOddsAdjustment?: number;
  liveMinOddsViolationAction?: string;
  liveMaxOddsViolationAction?: string;
  matchRemovalMinute?: number;
  matchRemovalAction?: string;
  liveBettingDelaySeconds?: number;
  // Price the coupon's final validation from the provider, per feed.
  liveForceFetchEnabled?: boolean;
  lineForceFetchEnabled?: boolean;
  systemBetsEnabled?: boolean;
  combinationBoostEnabled?: boolean;
  combinationInsuranceEnabled?: boolean;
  mixLiveAndLineEnabled?: boolean;
  basketballMixLiveAndLineEnabled?: boolean;
  mixFootballAndBasketballEnabled?: boolean;
  // Virtual football / virtual basketball: cross-sport combine only. Per-feed
  // on/off lives on the sport/feed switches (entity_suspension), not here.
  mixVirtualFootballAndOthersEnabled?: boolean;
  mixVirtualBasketballAndOthersEnabled?: boolean;
  oddsChangeAllowed?: boolean;
  couponCancelWindowMinutes?: number;
  allowSameEventSelections?: boolean;
  u19Allowed?: boolean;
  u20Allowed?: boolean;
  spareAllowed?: boolean;
  womenAllowed?: boolean;
  sundayEnabled?: boolean;
  mondayEnabled?: boolean;
  tuesdayEnabled?: boolean;
  wednesdayEnabled?: boolean;
  thursdayEnabled?: boolean;
  fridayEnabled?: boolean;
  saturdayEnabled?: boolean;
  weeklyBulletinEnabled?: boolean;
  // Shows the win probability column to the dealer. Strict Admin writes it,
  // only on the system, admin -> agent and admin -> dealer rows.
  winProbabilityEnabled?: boolean;
  // The dealer exchange commission rate in percent, 0 to 100 with two
  // decimals (DEALER-EXCHANGE-PLAN §14b D6). Strict Admin writes it, on the
  // same rows as winProbabilityEnabled; the system default is 10.
  exchangeCommissionPercent?: number;
  // Cash out (on/off, house margin in %, max amount per cash out, on/off for
  // single bets). Every level writes them for its own tree; the parent's
  // value is the ceiling, like the other rules.
  cashoutEnabled?: boolean;
  cashoutMarginPercent?: number;
  cashoutMaxAmount?: number;
  cashoutSingleEnabled?: boolean;
}

export interface BettingRulesResponse {
  systemRules: BettingRules;
  ownRules: BettingRules | null;
  targetRules: BettingRules | null;
  targetOwnRules?: BettingRules | null;
}

export interface GetBettingRulesParams {
  targetUsername?: string;
}

export async function getBettingRules(
  props: QueryProps<GetBettingRulesParams>
): Promise<BettingRulesResponse> {
  const res = await api.client.get("/betting-rules/editor", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
}
